import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { LabeledButtonMultiple } from "@loanbossinc/component-library";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";

import { actionCreators as dyDashboardSelections } from "../../reportingComponents/debtYieldCalculationDashboard/debtYieldRegularCalculationDashboard/debtYieldRegularCalculationDashboard.store";
import { actionCreators as dySetupActionCreators } from "../../reportComponentsSetup/debtYieldSetup/debtYieldSetup.store";
import { actionCreators as drawerActionCreators } from "../lenderReportingDrawer.store";
import { actionCreators as fieldManagementActionCreators } from "../field-management/fieldManagement.store";
import { actionCreators as sourceFileFieldActionCreators } from "../field-management/source-file-field/sourceFileField.store";

import { actionCreators as dyLineItemsActionCreators } from "./debtYieldLineItemManagement.store";
import DerivedFromLBLineItem from "./derivedFromLBLineItem";
import FromFileLineItem from "./fromFileLineItem";
import { StyledSecondaryButton, StyledButtonGroup, StyledPrimaryButton, Container, HeaderContainer } from "./styles";

const DebtYieldManagement = props => {
  const {
    lineItemType,
    activeLoanId,
    isBalanceLoading,
    isTotalBalanceLoading,
    selectedLoanBalance,
    getSourceFilesByDeal,
    match: {
      params: { dealId, reportId }
    },
    setDYLineItemSelections,
    debtYieldCalculations,
    setDebtYieldCalculationDashboardSelections,
    setDebtYieldSetupSelections,
    setFieldSelections,
    setDrawerSelections,
    setSourceFileFieldSelections,
    getMostRecentAsOfDateAmongRGI,
    getMostRecentProjectedAsOfDateAmongRGI,
    recentAsOfDate,
    isProjected,
    loanCurrentPrincipalBalance
  } = props;

  const [loanValue, setSelectedAmountValue] = useState(selectedLoanBalance);
  const [outstandingDebtSelected, setIsOutstandingDebtSelected] = useState(true);
  const [isLabeledButtonShow, setIsLabeledButtonShow] = useState(false);
  useEffect(() => {
    getSourceFilesByDeal({ dealId });
  }, [dealId]);

  useEffect(() => () => setDYLineItemSelections({ lineItemType: "fromFile", selectedLoanBalance: null }), []);

  useEffect(() => {
    if (!recentAsOfDate) {
      isProjected ? getMostRecentProjectedAsOfDateAmongRGI({ reportGroupId: reportId })
                  : getMostRecentAsOfDateAmongRGI({ reportGroupId: reportId });
    }
  }, [reportId, recentAsOfDate]);

  const onCancel = () => {
    setDebtYieldCalculationDashboardSelections({ isLenderReportingDrawerOpen: false, initialDrawerSectionName: null });
  };

  const onSelectedSourceFile = sourceFile => {
    setDrawerSelections({ currentSectionName: "field-management" });
    setFieldSelections({ currentSelectedFieldType: "file", isAdding: true, isFromDebtYieldCalculation: true });
    setSourceFileFieldSelections({ selectedSourceFile: sourceFile });
  };

  const onDone = () => {
    if (lineItemType === "derivedFromLB") {
      const updatedTotalValuesForLoans =
        debtYieldCalculations &&
        debtYieldCalculations.map(calc => {
          if (calc.id !== activeLoanId) {
            return calc;
          }
          const updatedLineItem = {
            lineItemType,
            value: loanValue ?? loanCurrentPrincipalBalance,
            outstandingDebtSelected
          };

          return { ...calc, lineItem: updatedLineItem, loanDebtYieldTotal: updatedLineItem.value };
        });
      setDebtYieldSetupSelections({ debtYieldCalculations: updatedTotalValuesForLoans });
      setDebtYieldCalculationDashboardSelections({ isLenderReportingDrawerOpen: false, initialDrawerSectionName: null });
    }
  };

  const CALCULATION_TYPES = [
    {
      label: "Captured from file",
      onClick: () => {
        setDYLineItemSelections({ lineItemType: "fromFile" });
      },
      iconName: "description",
      selected: lineItemType === "fromFile"
    },
    {
      label: "Derived from LoanBoss",
      onClick: () => {
        setDYLineItemSelections({ lineItemType: "derivedFromLB" });
      },
      iconName: "computer",
      selected: lineItemType === "derivedFromLB"
    }
  ];

  return (
    <Container>
      {!isLabeledButtonShow && (
        <HeaderContainer>
          <LabeledButtonMultiple options={CALCULATION_TYPES} />
        </HeaderContainer>
      )}
      {lineItemType === "fromFile" && (
        <FromFileLineItem
          {...props}
          onSelectedSourceFile={onSelectedSourceFile}
          setShowLabeledButton={isShow => setIsLabeledButtonShow(isShow)}
          isLabeledButtonShow={isLabeledButtonShow}
        />
      )}
      {lineItemType === "derivedFromLB" && (
        <>
          <DerivedFromLBLineItem {...props} setSelectedAmountValue={setSelectedAmountValue} setIsOutstandingDebtSelected={setIsOutstandingDebtSelected} />
          <StyledButtonGroup>
            <StyledSecondaryButton size="sm" label="Cancel" onClick={onCancel} />
            <StyledPrimaryButton size="sm" label="Save" disabled={isBalanceLoading || isTotalBalanceLoading} onClick={onDone} />
          </StyledButtonGroup>
        </>
      )}
    </Container>
  );
};

const mapStateToProps = ({ lenderReportDebtYieldLineItemManagement, lenderReportsDebtYieldSetup, lenderReportingDrawer, lenderReportFieldManagement }) => ({
  ...lenderReportDebtYieldLineItemManagement,
  ...lenderReportsDebtYieldSetup,
  ...lenderReportingDrawer,
  ...lenderReportFieldManagement
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    ...dyLineItemsActionCreators,
    ...dyDashboardSelections,
    ...dySetupActionCreators,
    ...drawerActionCreators,
    ...fieldManagementActionCreators,
    ...sourceFileFieldActionCreators
  },
  dispatch
);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(DebtYieldManagement);
